/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */

import React from 'react';
import Figure from '../Figure';
import FigCaption from '../FigCaption';
import FigContainer from '../FigContainer';
import CategoryHeader from '../CategoryHeader';

/* eslint-disable prettier/prettier */
import IconAttachFile from '../../../../../../Icon/IconAttachFile';
import IconAttachMoney from '../../../../../../Icon/IconAttachMoney';
import IconBorderAll from '../../../../../../Icon/IconBorderAll';
import IconBorderBottom from '../../../../../../Icon/IconBorderBottom';
import IconBorderClear from '../../../../../../Icon/IconBorderClear';
import IconBorderColor from '../../../../../../Icon/IconBorderColor';
import IconBorderHorizontal from '../../../../../../Icon/IconBorderHorizontal';
import IconBorderInner from '../../../../../../Icon/IconBorderInner';
import IconBorderLeft from '../../../../../../Icon/IconBorderLeft';
import IconBorderOuter from '../../../../../../Icon/IconBorderOuter';
import IconBorderRight from '../../../../../../Icon/IconBorderRight';
import IconBorderStyle from '../../../../../../Icon/IconBorderStyle';
import IconBorderTop from '../../../../../../Icon/IconBorderTop';
import IconBorderVertical from '../../../../../../Icon/IconBorderVertical';
import IconBubbleChart from '../../../../../../Icon/IconBubbleChart';
import IconDragHandle from '../../../../../../Icon/IconDragHandle';
import IconFormatAlignCenter from '../../../../../../Icon/IconFormatAlignCenter';
import IconFormatAlignJustify from '../../../../../../Icon/IconFormatAlignJustify';
import IconFormatAlignLeft from '../../../../../../Icon/IconFormatAlignLeft';
import IconFormatAlignRight from '../../../../../../Icon/IconFormatAlignRight';
import IconFormatBold from '../../../../../../Icon/IconFormatBold';
import IconFormatClear from '../../../../../../Icon/IconFormatClear';
import IconFormatColorFill from '../../../../../../Icon/IconFormatColorFill';
import IconFormatColorReset from '../../../../../../Icon/IconFormatColorReset';
import IconFormatColorText from '../../../../../../Icon/IconFormatColorText';
import IconFormatIndentDecrease from '../../../../../../Icon/IconFormatIndentDecrease';
import IconFormatIndentIncrease from '../../../../../../Icon/IconFormatIndentIncrease';
import IconFormatItalic from '../../../../../../Icon/IconFormatItalic';
import IconFormatLineSpacing from '../../../../../../Icon/IconFormatLineSpacing';
import IconFormatListBulleted from '../../../../../../Icon/IconFormatListBulleted';
import IconFormatListNumbered from '../../../../../../Icon/IconFormatListNumbered';
import IconFormatPaint from '../../../../../../Icon/IconFormatPaint';
import IconFormatQuote from '../../../../../../Icon/IconFormatQuote';
import IconFormatShapes from '../../../../../../Icon/IconFormatShapes';
import IconFormatSize from '../../../../../../Icon/IconFormatSize';
import IconFormatStrikethrough from '../../../../../../Icon/IconFormatStrikethrough';
import IconFormatTextdirectionLToR from '../../../../../../Icon/IconFormatTextdirectionLToR';
import IconFormatTextdirectionRToL from '../../../../../../Icon/IconFormatTextdirectionRToL';
import IconFormatUnderlined from '../../../../../../Icon/IconFormatUnderlined';
import IconFunctions from '../../../../../../Icon/IconFunctions';
import IconHighlight from '../../../../../../Icon/IconHighlight';
import IconInsertChart from '../../../../../../Icon/IconInsertChart';
import IconInsertComment from '../../../../../../Icon/IconInsertComment';
import IconInsertDriveFile from '../../../../../../Icon/IconInsertDriveFile';
import IconInsertEmoticon from '../../../../../../Icon/IconInsertEmoticon';
import IconInsertInvitation from '../../../../../../Icon/IconInsertInvitation';
import IconInsertLink from '../../../../../../Icon/IconInsertLink';
import IconInsertPhoto from '../../../../../../Icon/IconInsertPhoto';
import IconLinearScale from '../../../../../../Icon/IconLinearScale';
import IconMergeType from '../../../../../../Icon/IconMergeType';
import IconModeComment from '../../../../../../Icon/IconModeComment';
import IconModeEdit from '../../../../../../Icon/IconModeEdit';
import IconMonetizationOn from '../../../../../../Icon/IconMonetizationOn';
import IconMoneyOff from '../../../../../../Icon/IconMoneyOff';
import IconMultilineChart from '../../../../../../Icon/IconMultilineChart';
import IconPieChart from '../../../../../../Icon/IconPieChart';
import IconPieChartOutlined from '../../../../../../Icon/IconPieChartOutlined';
import IconPublish from '../../../../../../Icon/IconPublish';
import IconShortText from '../../../../../../Icon/IconShortText';
import IconShowChart from '../../../../../../Icon/IconShowChart';
import IconSpaceBar from '../../../../../../Icon/IconSpaceBar';
import IconStrikethroughS from '../../../../../../Icon/IconStrikethroughS';
import IconTextFields from '../../../../../../Icon/IconTextFields';
import IconTitle from '../../../../../../Icon/IconTitle';
import IconVerticalAlignBottom from '../../../../../../Icon/IconVerticalAlignBottom';
import IconVerticalAlignCenter from '../../../../../../Icon/IconVerticalAlignCenter';
import IconVerticalAlignTop from '../../../../../../Icon/IconVerticalAlignTop';
import IconWrapText from '../../../../../../Icon/IconWrapText';

export default function EditorIcons() {
  return (
    <div>
      <CategoryHeader>editor</CategoryHeader>
      <FigContainer>
        <Figure tabIndex={0}>
          <IconAttachFile size="32"/>
          <FigCaption>
            IconAttachFile
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconAttachMoney size="32"/>
          <FigCaption>
            IconAttachMoney
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderAll size="32"/>
          <FigCaption>
            IconBorderAll
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderBottom size="32"/>
          <FigCaption>
            IconBorderBottom
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderClear size="32"/>
          <FigCaption>
            IconBorderClear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderColor size="32"/>
          <FigCaption>
            IconBorderColor
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderHorizontal size="32"/>
          <FigCaption>
            IconBorderHorizontal
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderInner size="32"/>
          <FigCaption>
            IconBorderInner
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderLeft size="32"/>
          <FigCaption>
            IconBorderLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderOuter size="32"/>
          <FigCaption>
            IconBorderOuter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderRight size="32"/>
          <FigCaption>
            IconBorderRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderStyle size="32"/>
          <FigCaption>
            IconBorderStyle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderTop size="32"/>
          <FigCaption>
            IconBorderTop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBorderVertical size="32"/>
          <FigCaption>
            IconBorderVertical
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconBubbleChart size="32"/>
          <FigCaption>
            IconBubbleChart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconDragHandle size="32"/>
          <FigCaption>
            IconDragHandle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatAlignCenter size="32"/>
          <FigCaption>
            IconFormatAlignCenter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatAlignJustify size="32"/>
          <FigCaption>
            IconFormatAlignJustify
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatAlignLeft size="32"/>
          <FigCaption>
            IconFormatAlignLeft
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatAlignRight size="32"/>
          <FigCaption>
            IconFormatAlignRight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatBold size="32"/>
          <FigCaption>
            IconFormatBold
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatClear size="32"/>
          <FigCaption>
            IconFormatClear
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatColorFill size="32"/>
          <FigCaption>
            IconFormatColorFill
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatColorReset size="32"/>
          <FigCaption>
            IconFormatColorReset
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatColorText size="32"/>
          <FigCaption>
            IconFormatColorText
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatIndentDecrease size="32"/>
          <FigCaption>
            IconFormatIndentDecrease
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatIndentIncrease size="32"/>
          <FigCaption>
            IconFormatIndentIncrease
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatItalic size="32"/>
          <FigCaption>
            IconFormatItalic
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatLineSpacing size="32"/>
          <FigCaption>
            IconFormatLineSpacing
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatListBulleted size="32"/>
          <FigCaption>
            IconFormatListBulleted
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatListNumbered size="32"/>
          <FigCaption>
            IconFormatListNumbered
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatPaint size="32"/>
          <FigCaption>
            IconFormatPaint
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatQuote size="32"/>
          <FigCaption>
            IconFormatQuote
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatShapes size="32"/>
          <FigCaption>
            IconFormatShapes
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatSize size="32"/>
          <FigCaption>
            IconFormatSize
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatStrikethrough size="32"/>
          <FigCaption>
            IconFormatStrikethrough
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatTextdirectionLToR size="32"/>
          <FigCaption>
            IconFormatTextdirectionLToR
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatTextdirectionRToL size="32"/>
          <FigCaption>
            IconFormatTextdirectionRToL
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFormatUnderlined size="32"/>
          <FigCaption>
            IconFormatUnderlined
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconFunctions size="32"/>
          <FigCaption>
            IconFunctions
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconHighlight size="32"/>
          <FigCaption>
            IconHighlight
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertChart size="32"/>
          <FigCaption>
            IconInsertChart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertComment size="32"/>
          <FigCaption>
            IconInsertComment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertDriveFile size="32"/>
          <FigCaption>
            IconInsertDriveFile
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertEmoticon size="32"/>
          <FigCaption>
            IconInsertEmoticon
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertInvitation size="32"/>
          <FigCaption>
            IconInsertInvitation
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertLink size="32"/>
          <FigCaption>
            IconInsertLink
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconInsertPhoto size="32"/>
          <FigCaption>
            IconInsertPhoto
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconLinearScale size="32"/>
          <FigCaption>
            IconLinearScale
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMergeType size="32"/>
          <FigCaption>
            IconMergeType
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconModeComment size="32"/>
          <FigCaption>
            IconModeComment
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconModeEdit size="32"/>
          <FigCaption>
            IconModeEdit
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMonetizationOn size="32"/>
          <FigCaption>
            IconMonetizationOn
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMoneyOff size="32"/>
          <FigCaption>
            IconMoneyOff
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconMultilineChart size="32"/>
          <FigCaption>
            IconMultilineChart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPieChart size="32"/>
          <FigCaption>
            IconPieChart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPieChartOutlined size="32"/>
          <FigCaption>
            IconPieChartOutlined
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconPublish size="32"/>
          <FigCaption>
            IconPublish
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShortText size="32"/>
          <FigCaption>
            IconShortText
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconShowChart size="32"/>
          <FigCaption>
            IconShowChart
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconSpaceBar size="32"/>
          <FigCaption>
            IconSpaceBar
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconStrikethroughS size="32"/>
          <FigCaption>
            IconStrikethroughS
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTextFields size="32"/>
          <FigCaption>
            IconTextFields
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconTitle size="32"/>
          <FigCaption>
            IconTitle
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVerticalAlignBottom size="32"/>
          <FigCaption>
            IconVerticalAlignBottom
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVerticalAlignCenter size="32"/>
          <FigCaption>
            IconVerticalAlignCenter
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconVerticalAlignTop size="32"/>
          <FigCaption>
            IconVerticalAlignTop
          </FigCaption>
        </Figure>
        <Figure tabIndex={0}>
          <IconWrapText size="32"/>
          <FigCaption>
            IconWrapText
          </FigCaption>
        </Figure>
      </FigContainer>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/website/app/demos/Icon/components/categories/EditorIcons.js